/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
export type IAttributesFilterVariant_FilterListLevelVariant_Fragment = {
  __typename?: 'FilterListLevelVariant';
  searchPlaceholder?: string | null;
  appliedFiltersCount: number;
  appliedFilters: Array<{
    __typename?: 'FilterPayloadListValue';
    value: string;
    code: string;
    label?: string | null;
    sublabel?: string | null;
    parentIds?: Array<string> | null;
    hasChildren?: boolean | null;
    lastLevelFilterCount?: number | null;
    siblingCounts?: number | null;
  }>;
};

export type IAttributesFilterVariant_FilterListVariant_Fragment = {
  __typename?: 'FilterListVariant';
  searchPlaceholder?: string | null;
  appliedFiltersCount: number;
  filterGroups: Array<{
    __typename?: 'FilterGroupV2';
    label?: string | null;
    availableFilters: Array<{
      __typename?: 'FilterPayloadValue';
      label?: string | null;
      value: string;
      sublabel?: string | null;
    }>;
  }>;
  appliedFilters: Array<{
    __typename?: 'FilterPayloadValue';
    label?: string | null;
    value: string;
    sublabel?: string | null;
  }>;
};

export type IAttributesFilterVariant_FilterRangeVariant_Fragment = {
  __typename?: 'FilterRangeVariant';
  range: { __typename?: 'FilterRange'; min: number; max: number };
  activeRange?: { __typename?: 'FilterRange'; min: number; max: number } | null;
};

export type IAttributesFilterVariantFragment =
  | IAttributesFilterVariant_FilterListLevelVariant_Fragment
  | IAttributesFilterVariant_FilterListVariant_Fragment
  | IAttributesFilterVariant_FilterRangeVariant_Fragment;

export const AttributesFilterVariantFragmentDoc = gql`
  fragment AttributesFilterVariant on FilterVariant {
    ... on FilterListVariant {
      searchPlaceholder
      filterGroups {
        label
        availableFilters {
          label
          value
          sublabel
        }
      }
      appliedFilters {
        label
        value
        sublabel
      }
      appliedFiltersCount
    }
    ... on FilterRangeVariant {
      range {
        min
        max
      }
      activeRange {
        min
        max
      }
    }
    ... on FilterListLevelVariant {
      searchPlaceholder
      appliedFilters {
        value
        code
        label
        sublabel
        parentIds
        hasChildren
        lastLevelFilterCount
        siblingCounts
      }
      appliedFiltersCount
    }
  }
`;
